import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../dishAssignmentState/dishAssignmentContext';
import { CreateSubcategoryModalState } from './createSubcategoryModalContext/createSubcategoryModalState/CreateSubcategoryModalState';
import ModalLayout from 'components/ModalLayout';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import { CreateSubcategoryModal } from './components/CreateSubcategoryModal/CreateSubcategoryModal';

export const CreateSubcategoryModalPage: React.FC = () => {
	const { changeIsShowModalWindowToCreateSubcategory, isShowModalWindowToCreateSubcategory } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const handleClose = () => {
		changeIsShowModalWindowToCreateSubcategory(false);
	};

	return (
		<ModalLayout setIsShowModal={handleClose} isVisible={isShowModalWindowToCreateSubcategory} width="55%">
			<CreateSubcategoryModalState>
				<CreateSubcategoryModal />
				<ModalWindows />
			</CreateSubcategoryModalState>
		</ModalLayout>
	);
};
